/**
 * News Hero Block - AJAX Search Handler
 */
export default class NewsHero {
  constructor(el) {
    this.$el = $(el);
    this.$form = this.$el.find('.gg-news-hero__search-form');
    this.$input = this.$form.find('input[name="keywords"]');
    this.$btnClear = this.$form.find('.gg-news-hero__search-btn-clear');
    this.isSearchNewsPage = this.$el.hasClass('search-ajax');
  }

  init() {
    this.$btnClear.on('click', () => {
      this.$input.val('');
      this.$btnClear.addClass('hidden');
      if (this.isSearchNewsPage) {
        this.handleSearch();
      }
    });
    this.$input.on('input', () => {
      if (this.$input.val().trim()) {
        this.$btnClear.removeClass('hidden');
      } else {
        this.$btnClear.addClass('hidden');
      }
    });
    if (this.isSearchNewsPage) {
      this.bindEvents();
    }
  }

  bindEvents() {
    // Intercept form submit on search news page
    this.$form.on('submit', (e) => {
      e.preventDefault();
      this.handleSearch();
    });
  }

  handleSearch() {
    const searchQuery = this.$input.val().trim();
    $(document).trigger('searchFromBanner', [searchQuery]);
  }
}

$(document).ready(() => {
  $('.gg-news-hero').each((_index, el) => {
    new NewsHero(el).init();
  });
});
